
import makerjs from "makerjs";/**
* 计算两点间的弦长
* @param {Object} p1 - 第一个点坐标 {x, y}
* @param {Object} p2 - 第二个点坐标 {x, y}
* @returns {number} 弦长值
*/
function calculateChordLength(p1, p2) {
 const dx = p2.x - p1.x;
 const dy = p2.y - p1.y;
 return Math.sqrt(dx*dx + dy*dy);
}
function C26(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       w = W * 1 * myZoom,
       rx=w/2,ry=h/2,
       glassH = h, glassW = w;
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
   if (h !== 0) {
       var TxtH = H;
   } 
   if (w !== 0) {
       var TxtW = W;
   }

   var drawAbnormalShapeC26=new makerjs.models.Ellipse(rx, ry);

   var drawAbnormalShapeC26MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([rx+ markShift, -ry], [rx+ markShift, ry]),
        "RightShortUpline": new makerjs.paths.Line([rx, ry], [rx+2*markShift, ry]),
        "RightShortDnline": new makerjs.paths.Line([rx, -ry], [rx+2*markShift, -ry]),
       }
   };
   var drawAbnormalShapeC26MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([-rx, -ry-markShift], [rx, -ry-markShift]),
        "BotmShortLfline": new makerjs.paths.Line([-rx, -ry], [-rx, -ry-2*markShift]),
        "BotmShortRTline": new makerjs.paths.Line([rx, -ry], [rx, -ry-2*markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeC26MarkW, TxtW, [-rx, -ry-3*markShift], [rx, -ry-3*markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeC26MarkH, TxtH, [rx+ 2*markShift, -ry], [rx+ 2*markShift, ry]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeC26: drawAbnormalShapeC26,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC26: drawAbnormalShapeC26,
        drawAbnormalShapeC26MarkH:drawAbnormalShapeC26MarkH,
        drawAbnormalShapeC26MarkW:drawAbnormalShapeC26MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C26;